'use client'

import Link from 'next/link'
import Image from 'next/image'
import { useCookieValue } from '@/Cookies/useCookies'

export const Logo = () => {
  const brandCode = useCookieValue('vi-brand')

  // Determine logo based on brand variant
  // If UK brand, use UK-specific logo, otherwise use default/US logo
  const logoSrc =
    brandCode === 'VANISHING_INC_UK'
      ? '/images/vanishing-inc-uk.svg'
      : '/images/vanishing-inc.svg'

  const altText =
    brandCode === 'VANISHING_INC_UK'
      ? 'Vanishing Inc. UK Logo'
      : 'Vanishing Inc. Logo'

  return (
    <Link href="/">
      <span className="sr-only">Vanishing Inc</span>
      <Image
        className="h-6 w-auto"
        src={logoSrc}
        alt={altText}
        width={578}
        height={83}
      />
    </Link>
  )
}
